export default {
    "name": "CourseBySlug",
    "kind": "HoudiniQuery",
    "hash": "aa9e181a00f1541181c4b04f3b086150a708e142f79e918ccf66cd8d432e1a0f",

    "raw": `query CourseBySlug($slug: String!) {
  course(where: {slug: $slug}) {
    id
    name
    shortDescription
    slug
    keyTakeaways
    thumbnail {
      ...Image
      id
    }
    featuredThumbnail {
      ...Image
      id
    }
  }
}

fragment Image on Asset {
  url(transformation: {document: {output: {format: webp}}})
  sm: url(
    transformation: {image: {resize: {width: 320}}, document: {output: {format: webp}}}
  )
  md: url(
    transformation: {image: {resize: {width: 640}}, document: {output: {format: webp}}}
  )
  lg: url(
    transformation: {image: {resize: {width: 1024}}, document: {output: {format: webp}}}
  )
  xl: url(
    transformation: {image: {resize: {width: 1280}}, document: {output: {format: webp}}}
  )
  social: url(
    transformation: {image: {resize: {width: 1200, height: 630, fit: crop}}, document: {output: {format: png}}}
  )
  width
  id
  __typename
}
`,

    "rootType": "Query",

    "selection": {
        "fields": {
            "course": {
                "type": "Course",
                "keyRaw": "course(where: {slug: $slug})",
                "nullable": true,

                "selection": {
                    "fields": {
                        "id": {
                            "type": "ID",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "nullable": true,
                            "visible": true
                        },

                        "shortDescription": {
                            "type": "String",
                            "keyRaw": "shortDescription",
                            "nullable": true,
                            "visible": true
                        },

                        "slug": {
                            "type": "String",
                            "keyRaw": "slug",
                            "nullable": true,
                            "visible": true
                        },

                        "keyTakeaways": {
                            "type": "String",
                            "keyRaw": "keyTakeaways",
                            "visible": true
                        },

                        "thumbnail": {
                            "type": "Asset",
                            "keyRaw": "thumbnail",

                            "selection": {
                                "fields": {
                                    "url": {
                                        "type": "String",
                                        "keyRaw": "url(transformation: {document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "sm": {
                                        "type": "String",
                                        "keyRaw": "sm(transformation: {image: {resize: {width: 320}}, document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "md": {
                                        "type": "String",
                                        "keyRaw": "md(transformation: {image: {resize: {width: 640}}, document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "lg": {
                                        "type": "String",
                                        "keyRaw": "lg(transformation: {image: {resize: {width: 1024}}, document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "xl": {
                                        "type": "String",
                                        "keyRaw": "xl(transformation: {image: {resize: {width: 1280}}, document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "social": {
                                        "type": "String",
                                        "keyRaw": "social(transformation: {image: {resize: {width: 1200, height: 630, fit: crop}}, document: {output: {format: png}}})",
                                        "visible": true
                                    },

                                    "width": {
                                        "type": "Float",
                                        "keyRaw": "width",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "__typename": {
                                        "type": "String",
                                        "keyRaw": "__typename",
                                        "visible": true
                                    }
                                },

                                "fragments": {
                                    "Image": {
                                        "arguments": {}
                                    }
                                }
                            },

                            "visible": true
                        },

                        "featuredThumbnail": {
                            "type": "Asset",
                            "keyRaw": "featuredThumbnail",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "url": {
                                        "type": "String",
                                        "keyRaw": "url(transformation: {document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "sm": {
                                        "type": "String",
                                        "keyRaw": "sm(transformation: {image: {resize: {width: 320}}, document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "md": {
                                        "type": "String",
                                        "keyRaw": "md(transformation: {image: {resize: {width: 640}}, document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "lg": {
                                        "type": "String",
                                        "keyRaw": "lg(transformation: {image: {resize: {width: 1024}}, document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "xl": {
                                        "type": "String",
                                        "keyRaw": "xl(transformation: {image: {resize: {width: 1280}}, document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "social": {
                                        "type": "String",
                                        "keyRaw": "social(transformation: {image: {resize: {width: 1200, height: 630, fit: crop}}, document: {output: {format: png}}})",
                                        "visible": true
                                    },

                                    "width": {
                                        "type": "Float",
                                        "keyRaw": "width",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "__typename": {
                                        "type": "String",
                                        "keyRaw": "__typename",
                                        "visible": true
                                    }
                                },

                                "fragments": {
                                    "Image": {
                                        "arguments": {}
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "slug": "String"
        },

        "types": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=a0c6f51c85e6cd8000524b4cca3fc9f894549a4c7d80a2ae3d46311bdf556c39";